export const getSearchForUsersReduxKey = ({ userType }) => `users-${userType || 'all'}`;
